import { FC } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { Box } from '@mui/material'

// This will require _either_ `to` _or_ `href` to be supplied (not both nor allow neither)
export type LinkBaseProps =
  | { to: LinkProps['to']; href?: never; onClick?: () => void }
  | { href: string; to?: never; onClick?: () => void }

const LinkBase: FC<LinkBaseProps> = ({ to, href, onClick, children, ...rest }) => (
  <Box
    {...{
      ...rest,
      to,
      href,
      component: to ? Link : 'a',
      // Will open any `href` link in a new tab
      target: href ? '_blank' : '_self',
      rel: href ? 'noreferrer' : undefined,
      style: { textDecoration: 'none' },
      onClick,
    }}
  >
    {children}
  </Box>
)

export default LinkBase
